import React from 'react';
import PropTypes from 'prop-types';
import { Chip, makeStyles } from '@material-ui/core';
import { useAutomation } from '../../hooks/useAutomation';
import { AUTOMATION_STRATEGIES, DEFAULT_AUTOMATION_STRATEGY } from '../../helpers/constants';

const useStyles = makeStyles({
  chip: {
    backgroundColor: '#E7CBEC',
    color: '#9C27B0',
    fontSize: '14px',
    fontWeight: '600',
    height: '28px',
  },
});

const propTypes = {
  lobsangEventId: PropTypes.number.isRequired,
};
const defaultProps = {};

function AutomationChip({ lobsangEventId }) {
  const classes = useStyles();

  // Query automation data.
  const { data, isLoading, isError } = useAutomation(lobsangEventId);

  if (isLoading || isError) {
    return null;
  }
  if (!data.current_strategy) {
    return <Chip className={classes.chip} color="primary" label={`${DEFAULT_AUTOMATION_STRATEGY} Priced`} />;
  }

  const currentStrategy =
    data.current_strategy.automation_strategy in AUTOMATION_STRATEGIES
      ? AUTOMATION_STRATEGIES[data.current_strategy.automation_strategy].label
      : data.current_strategy.automation_strategy;
  return <Chip className={classes.chip} color="primary" label={`${currentStrategy} Priced`} />;
}

AutomationChip.propTypes = propTypes;
AutomationChip.defaultProps = defaultProps;

export default AutomationChip;
